import * as React from 'react';

type SvgAppleDarkProps = React.SVGProps<SVGSVGElement>;

const SvgAppleDark = (props: SvgAppleDarkProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="33"
    fill="none"
    viewBox="0 0 28 33"
  >
    <path
      fill="#1A1A1A"
      d="M20.412.537h.238c.19 2.233-.71 3.9-1.803 5.109-1.073 1.2-2.543 2.363-4.92 2.187-.158-2.2.743-3.745 1.835-4.95 1.014-1.124 2.87-2.123 4.65-2.346M27.606 23.774v.062c-.668 1.916-1.62 3.558-2.783 5.082-1.062 1.383-2.363 3.244-4.685 3.244-2.007 0-3.34-1.222-5.397-1.255-2.176-.034-3.372 1.022-5.362 1.287h-.678c-1.46-.2-2.64-1.296-3.499-2.283C2.67 26.995.712 23.227.35 18.406V16.99c.154-3.45 1.924-6.256 4.278-7.615 1.242-.723 2.95-1.34 4.85-1.064.815.12 1.648.384 2.377.645.692.252 1.557.698 2.376.674.555-.015 1.107-.289 1.666-.482 1.639-.56 3.245-1.203 5.362-.9 2.544.363 4.35 1.434 5.466 3.085-2.152 1.297-3.854 3.252-3.563 6.59.258 3.032 2.12 4.805 4.445 5.85"
    ></path>
  </svg>
);

export default SvgAppleDark;
